import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT, TEXT_ALIGN } from '../../foundations/typography';
import { PopoverVariantType } from '../popover/variants';
import { ModalVariantType } from './variants';
const MODAL_COMMON_TOKENS = (FOUNDATIONS, FONT) => ({
    popoverVariant: PopoverVariantType.MODAL,
    container: {
        background_color: FOUNDATIONS.color_comp_containers_bg,
        overflow_y: 'auto',
        display: 'flex',
        align_items: 'center',
        flex_flow: 'column nowrap',
        box_sizing: 'border-box',
    },
    headerContainer: {
        width: '100%',
        display: 'flex',
        flex_direction: 'column',
        gap: FOUNDATIONS.spacing_150,
    },
    headerContentContainer: {
        display: 'flex',
        flex_direction: 'row-reverse',
        align_items: 'center',
    },
    title: {
        // TODO: Use new font_weight token (FOUNDATIONS.font_weight_heading_xllm_h1_bold) when util is ready
        font_weight: FONT_WEIGHT.font_weight_600,
        color: FOUNDATIONS.color_neutral_font_50,
        text_align: TEXT_ALIGN.center,
    },
    titleContainer: {
        flex_grow: '1',
    },
    content: {
        margin_top: FOUNDATIONS.spacing_00,
        width: '100%',
        flex: 'auto',
        overflow_y: 'auto',
    },
    dragIconContainer: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
    },
    dragIcon: {
        width: '32px',
        height: '4px',
        color: FOUNDATIONS.color_neutral_bg_onsurface_55,
    },
    closeButtonContainer: {
        display: 'flex',
        justify_content: 'end',
        align_self: 'flex-start',
    },
    closeButtonIcon: {
        color: FOUNDATIONS.color_comp_actions_closebutton_primary_default_icon,
        width: FOUNDATIONS.size_350,
        height: FOUNDATIONS.size_350,
    },
});
export const getModalStyles = (FOUNDATIONS, FONT) => {
    return {
        [ModalVariantType.DEFAULT]: {
            ...MODAL_COMMON_TOKENS(FOUNDATIONS, FONT),
            container: {
                ...MODAL_COMMON_TOKENS(FOUNDATIONS, FONT).container,
                [DeviceBreakpointsType.DESKTOP]: {
                    border_radius: FOUNDATIONS.radius_comp_containers_modal_desktopradius_radiussize,
                    min_width: '37.5rem',
                    min_height: '15rem',
                    max_width: 'calc(100vw - 36px)',
                    max_height: 'calc(100vh - 36px)',
                },
                [DeviceBreakpointsType.TABLET]: {
                    border_radius: `${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} ${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} 0 0`,
                    min_width: '48rem',
                    min_height: '16rem',
                    max_width: '100vw',
                    max_height: '100vh',
                },
                [DeviceBreakpointsType.MOBILE]: {
                    border_radius: `${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} ${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} 0 0`,
                    max_width: '100vw',
                    max_height: '100vh',
                },
            },
            headerContainer: {
                ...MODAL_COMMON_TOKENS(FOUNDATIONS, FONT).headerContainer,
                [DeviceBreakpointsType.DESKTOP]: {
                    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_300}`,
                },
                [DeviceBreakpointsType.TABLET]: {
                    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_250}`,
                },
            },
            title: {
                ...MODAL_COMMON_TOKENS(FOUNDATIONS, FONT).title,
                [DeviceBreakpointsType.DESKTOP]: {
                    font_size: FOUNDATIONS.font_size_heading_xllm_h1,
                },
                [DeviceBreakpointsType.TABLET]: {
                    font_size: FOUNDATIONS.font_size_heading_s_h1,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    font_size: FOUNDATIONS.font_size_heading_s_h1,
                },
            },
            content: {
                ...MODAL_COMMON_TOKENS(FOUNDATIONS, FONT).content,
                [DeviceBreakpointsType.DESKTOP]: {
                    margin_bottom: FOUNDATIONS.spacing_150,
                    padding_left: FOUNDATIONS.spacing_300,
                    padding_right: FOUNDATIONS.spacing_300,
                },
                [DeviceBreakpointsType.TABLET]: {
                    margin_bottom: FOUNDATIONS.spacing_150,
                    padding_left: FOUNDATIONS.spacing_250,
                    padding_right: FOUNDATIONS.spacing_250,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    margin_bottom: FOUNDATIONS.spacing_150,
                    padding_left: FOUNDATIONS.spacing_250,
                    padding_right: FOUNDATIONS.spacing_250,
                },
            },
            footer: {
                [DeviceBreakpointsType.DESKTOP]: {
                    padding_bottom: FOUNDATIONS.spacing_150,
                    width: `calc(100% - (${FOUNDATIONS.spacing_300} + ${FOUNDATIONS.spacing_300}))`,
                },
                [DeviceBreakpointsType.TABLET]: {
                    width: `calc(100% - (${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.spacing_250}))`,
                    padding_bottom: FOUNDATIONS.spacing_150,
                },
                [DeviceBreakpointsType.MOBILE]: {
                    width: `calc(100% - (${FOUNDATIONS.spacing_250} + ${FOUNDATIONS.spacing_250}))`,
                    padding_bottom: FOUNDATIONS.spacing_150,
                },
            },
        },
    };
};
//# sourceMappingURL=styles.js.map